import { render, staticRenderFns } from "./SplitPartnerDialog.vue?vue&type=template&id=c607020e"
import script from "./SplitPartnerDialog.vue?vue&type=script&lang=js"
export * from "./SplitPartnerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports